import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function BankDetails() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const adminmob = queryParams.get('adminmob');
    const branchId = queryParams.get('branchId');
    const empmobile = queryParams.get('empmobile');
    const navigate = useNavigate();
    const [bankName, setBankName] = useState('');
    const [ifsc, setIfsc] = useState('');
    const [accountHolderName, setAccountHolderName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [upiId, setUpiId] = useState('');
    const udiseNumber= localStorage.getItem("udiseNumber")
     const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
    
          useEffect(() => {
                     const storedLanguage = localStorage.getItem('language') || 'English';
                     setLanguage(storedLanguage);
                   }, []);
        
    // Fetch bank details from Firebase when the component mounts
    useEffect(() => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Bank.json`;
        
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch bank details');
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    // Populate state with fetched data
                    setBankName(data.bank_name || '');
                    setIfsc(data.ifsc || '');
                    setAccountHolderName(data.accountholdername || '');
                    setAccountNumber(data.accnumber || '');
                    setUpiId(data.upiid || '');
                }
            })
            .catch(error => {
                console.error("Error fetching bank details: ", error);
            });
    }, [adminmob, branchId, empmobile]); // Dependencies to refetch if these change


    const handleSave = () => {
        const bankDetails = {
            bank_name: bankName,
            ifsc: ifsc,
            accountholdername: accountHolderName,
            accnumber: accountNumber,
            upiid: upiId
        };

        console.log("Bank Details to Save:", bankDetails); // Log the details

        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Bank.json`;
        console.log("URL:", url); // Log the URL

        fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bankDetails)
        })
        .then(response => {
            if (response.ok) {
                console.log("Bank details saved successfully!");
            } else {
                return response.json().then(err => { throw new Error(err.message); });
            }
        })
        .catch(error => {
            console.error("Error saving bank details: ", error);
        });
    };

    const handleClose = () => {
      navigate(-1); // Change '/profile' to the actual path of your profile page
  };

    return (
  
            <div className='main-content-of-page' >
            <div style={{ 
    border: '1px solid black', // Outer border
    borderRadius: '8px', // Rounded corners for the border
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Optional shadow for better appearance
   marginTop:'7%',
   width:'700px',
   height:'500px',
   justifyContent:'center',
   backgroundColor:'#b0dbfa',
   marginLeft:'25%'
}}>
    <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginTop: '30px', 
                            marginLeft: '620px' ,
                            fontWeight:'bold',
                        }} onClick={handleClose}> 
                            X 
                        </button>
  
    <div style={{ 
        fontWeight: 'bold', 
        fontSize: '24px', 
        marginBottom: '20px',
        textAlign:'center',
        marginTop:'0px',
        border:'2px solid black',
        width:'320px',
        marginLeft:'210px',
        borderRadius:'8px',
        backgroundColor:'#a1ccf5',
      
    }}>
        <label>{language === "English" ? "Bank Details" : "बँक तपशील"}</label>
    </div>

    {/* <div style={{ marginBottom: '15px',textAlign:'center' }}>
        <label style={{ fontWeight: 'bold', fontSize: '18px' }}>Bank Details:</label>
    </div> */}

    <div style={{ gap:'20px',display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'center' ,marginTop:'25px'}}>
        <label style={{ width: '150px', textAlign: 'right', marginRight: '10px',fontWeight:'bold' }}>{language === "English" ? " Bank Name" : "बँकेचे नाव"} </label>
        <input type="text" style={{ 
            width: '300px', // Set a specific width for the input box
            padding: "10px", 
            border: "1px solid black", 
            borderRadius: "6px", 
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' 
        }} 
        value={bankName} onChange={(e) => setBankName(e.target.value)} />
    </div>

    <div style={{ gap:'20px',display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'center' }}>
        <label style={{ width: '150px',fontWeight:'bold', textAlign: 'right', marginRight: '10px' }}>{language === "English" ? " IFSC Code" : "IFSC कोड"} </label>
        <input type="text" style={{ 
            width: '300px', 
            padding: "10px", 
            border: "1px solid black", 
            borderRadius: "6px", 
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' 
        }} 
        value={ifsc} onChange={(e) => setIfsc(e.target.value)} />
    </div>

    <div style={{gap:'20px',display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'center' }}>
        <label style={{ width: '150px',fontWeight:'bold', textAlign: 'right', marginRight: '10px' }}> {language === "English" ? " Account Holder's Name" : "खातेधारकाचे नाव"} </label>
        <input type="text" style={{ 
            width: '300px', 
            padding: "10px", 
            border: "1px solid black", 
            borderRadius: "6px", 
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' 
        }} 
        value={accountHolderName} onChange={(e) => setAccountHolderName(e.target.value)} />
    </div>

    <div style={{ gap:'20px',display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'center' }}>
        <label style={{ width: '150px',fontWeight:'bold', textAlign: 'right', marginRight: '10px' }}>  {language === "English" ? " Account Number" : "खाते क्रमांक"}</label>
        <input type="text" style={{ 
            width: '300px', 
            padding: "10px", 
            border: "1px solid black", 
            borderRadius: "6px", 
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' 
        }} 
        value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
    </div>

    <div style={{ gap:'20px',display: 'flex', alignItems: 'center', marginBottom: '20px', justifyContent: 'center' }}>
        <label style={{ width: '150px',fontWeight:'bold', textAlign: 'right', marginRight: '10px' }}> {language === "English" ? " UPI ID" : "UPI आयडी"} </label>
        <input type="text" style={{ 
            width: '300px', 
            padding: "10px", 
            border: "1px solid black", 
            borderRadius: "6px", 
            boxShadow: '0  1px 3px rgba(0, 0, 0, 0.1)' ,
           
        }} 
        value={upiId} onChange={(e) => setUpiId(e.target.value)} />
    </div>

    <div style={{ 
    display: 'flex', 
    justifyContent: 'center', // Center the button horizontally
    marginTop: '20px' // Optional: Add some margin for spacing
}}>
    <button style={{ 
        backgroundColor: '#1B4332', 
        color: '#fff', 
        border: 'none', 
        borderRadius: '5px', 
        cursor: 'pointer', 
        fontSize: '20px', 
        marginTop:'0px', 
    }} onClick={handleSave}> 
        Save 
    </button>

</div>
</div>
</div>
  
    );
}

export default BankDetails;